import { render, staticRenderFns } from "./AegBinderCommission.vue?vue&type=template&id=0053f668"
import script from "./AegBinderCommission.vue?vue&type=script&lang=js"
export * from "./AegBinderCommission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports